import React from "react";
import { useHistory } from "react-router-dom";

const StatusBadgeBody = (props) => {
  const { status, userType, className, link } = props;
  const history = useHistory();

  let statusName;
  let statusClass;

  if (status === "winner") {
    statusName = "Diterima";
    statusClass = status;
  } else if (
    status === "published" &&
    (userType === "pm" || userType === "client")
  ) {
    statusName = "Diterbitkan";
    statusClass = status;
  } else if (status === "published" && userType === "writer") {
    statusName = "Diterima";
    statusClass = "winner";
  } else if (status === "ongoing" && userType === "writer") {
    statusName = "Berjalan";
    statusClass = status;
  } else if (status === "ongoing" && userType !== "writer") {
    statusName = "Berjalan";
    statusClass = "sent";
  } else if (status === "ongoing" && userType === "finance") {
    statusName = "Lunas";
    statusClass = status;
  } else if (status === "reject" || status === "rejected") {
    statusName = "Ditolak";
    statusClass = "reject";
  } else if (status === "waiting") {
    statusName = "Menunggu";
    statusClass = "waiting";
  } else if (status === "approved") {
    statusName = "Diterima";
    statusClass = "Approved";
  } else if (status === "verified") {
    statusName = "Diterima";
    statusClass = "Terverifikasi";
  } else if (status === "revision") {
    statusName = "Revisi";
    statusClass = status;
  } else if (status === "sent") {
    statusName = "Terkirim";
    statusClass = status;
  } else if (status === "removed") {
    statusName = "Nonaktif";
    statusClass = status;
  } else if (status === "public") {
    statusName = "Publik";
    statusClass = "sent";
  } else if (status === "private") {
    statusName = "Private";
    statusClass = "sent";
  } else if (status === "done") {
    statusName = "Selesai";
    statusClass = "winner";
  } else if (status === "payment_waiting") {
    statusName = "Belum Dibayar";
    statusClass = "waiting";
  } else if (status === "draft") {
    statusName = "Draft";
    statusClass = "waiting";
  } else if (status === "confirmation_waiting") {
    statusName = "Menunggu Konfirmasi";
    statusClass = "sent";
  } else if (status === "confirmed") {
    statusName = "Terkonfirmasi";
    statusClass = "winner";
  } else if (status === "new") {
    statusName = "Baru";
    statusClass = "ongoing";
  } else if (status === "pm_approved" && userType === "writer") {
    statusName = "Terkirim";
    statusClass = "sent";
  } else if (status === "pm_approved" && userType !== "writer") {
    statusName = "Review Klien";
    statusClass = "sent";
  } else {
    statusName = status;
    statusClass = status;
  }

  return (
    <div
      onClick={() => history.push(link)}
      className={`status ${statusClass} ${className}`}
    >
      {statusName}
    </div>
  );
};

export default StatusBadgeBody;
